export const headerKeys = {
  auth: 'Authorization',
  locationId: 'Location-Id',
  ipAddress: 'X-LocalIP',
};
